import { gql } from 'apollo-angular';
import { Event } from '../../shared/entities/events/event';
import { Page } from '../../shared/entities/page/page';


export const EVENTS_QUERY = gql`
query eventsQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String, $states: [EventState])
{
  events: getEventsPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection},
      states: $states
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
        id
        deliveryDateTime
        lastFailedDateTime
        nextSendAttemptNotBefore
        entityId
        entityExternalId
        eventType
        deliveryAttempt
        state
        lastResponseCode
        lastResponseBody
        subscription{
          id
        }
        eventDatetime
        data
        generatedWebHookJson
      }
    }
}
`;

export interface EventsQueryResponse {
  loading: boolean;
  events:Page<Event>;
}
